module.exports = __webpack_public_path__ + "img/05180.55202bd6.png";